import WeekPicker from './src/week-picker'

import type { App } from 'vue'
import type { SFCWithInstall } from '@code-monkey-ui/utils'

const _WeekPicker = WeekPicker as SFCWithInstall<typeof WeekPicker>

_WeekPicker.install = (app: App) => {
  app.component(_WeekPicker.name!, _WeekPicker)
}

export default _WeekPicker
export const ElWeekPicker = _WeekPicker
export * from './src/constants'
export * from './src/props/week-picker'
export type { WeekPickerInstance } from './src/instance'
